import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'

export const ZDownloadImage = z.object({
  id: z.string(),
  fileName: z.string(),
  fileExtension: z.string(),
  associatedEntityId: z.string(),
  tenantId: z.string(),
  binaryData: z.string()
})

export const ZApiResponse = z.object({
  http_status: z.any(),
  data: ZDownloadImage,
  error: z.boolean(),
  error_message: z.optional(z.string())
})
export type DownloadImage = z.infer<typeof ZDownloadImage>

export async function downloadImage (
  siteId: string,
  locale: string, // en_US
  onSuccess: (downloadImage: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const DeviceManagementStrings = LanguageStrings().SiteManagementCollectionStrings.TableComponent
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const url = `/assetrest/api/v2/udp/tiq/sites/downloadFile?siteId=${siteId}&locale=${locale}`
  interceptedAxios.get(url, { timeout: 15000 })
    .then((response) => {
      const parseResponse = response.data
      // istanbul ignore else
      if (parseResponse.error === false) {
        // istanbul ignore else
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, parseResponse.http_status)
        } else {
          onFailure(parseResponse.error, parseResponse.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore next
      if (error.response !== undefined) {
        onFailure((error.response.data !== undefined || error.response.data !== null) ? error.response.data.error_message : DeviceManagementStrings.NetworkError, error.response.status)
      } else {
        onFailure(DeviceManagementStrings.NetworkError, 404)
      }
    })
}
